var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Chi phí đơn hàng")]),
      _c("h4", { staticClass: "text-danger rate panel-title" }, [
        _vm._v(
          "Tỉ giá " +
            _vm._s(_vm._f("formatNumber")(_vm.order.exchangeRate, "0,0"))
        )
      ])
    ]),
    _c("div", { staticClass: "panel-body" }, [
      _vm.order.promocode && _vm.order.promocode !== ""
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label text-primary" }, [
              _vm._v("\n                Mã giảm giá\n            ")
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary fb text-red" }, [
                _vm._v(_vm._s(_vm.order.promocode))
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Tiền hàng\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(_vm._s(_vm._f("formatNumber")(_vm.order.amountVND, "0,0")))
          ]),
          _vm._v("\n                ("),
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              "¥" +
                _vm._s(_vm._f("formatNumber")(_vm.order.amountCNY, "0,0.[000]"))
            )
          ]),
          _vm._v(")\n            ")
        ])
      ]),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Phí ship nội địa TQ\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(
              _vm._s(_vm._f("formatNumber")(_vm.order.feeShipCNVND, "0,0"))
            )
          ]),
          _vm._v("\n                ("),
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              "¥" +
                _vm._s(_vm._f("formatNumber")(_vm.order.feeShipCN, "0,0.[000]"))
            )
          ]),
          _vm._v(")\n            ")
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "fee-box collapse",
          on: {
            click: function($event) {
              return _vm.onCollapseFee("feeBuy")
            }
          }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _c("i", {
              staticClass: "fa",
              class: {
                "fa-caret-down": _vm.collapseFeeItem.feeBuy === true,
                "fa-caret-right": _vm.collapseFeeItem.feeBuy === false
              }
            }),
            _vm._v(" Phí dịch vụ\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(_vm._f("formatNumber")(_vm.order.feeBuyAmount, "0,0"))
              )
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeBuy === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v("\n                - Phí dịch vụ gốc\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(_vm._s(_vm._f("formatNumber")(_vm.feeBuyOrigin, "0,0")))
            ]),
            _vm._v("\n                ("),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(
                _vm._s(_vm._f("formatNumber")(_vm.order.feeBuy, "0,0")) + "%"
              )
            ]),
            _vm._v(")\n            ")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeBuy === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v("\n                - Chiết khấu\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(_vm._s(_vm._f("formatNumber")(_vm.feeBuyDiscount, "0,0")))
            ]),
            _vm._v("\n                ("),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(
                _vm._s(
                  _vm._f("formatNumber")(_vm.order.feeBuyDiscount, "0,0")
                ) + "%"
              )
            ]),
            _vm._v(")\n            ")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box collapse",
          on: {
            click: function($event) {
              return _vm.onCollapseFee("feeWeight")
            }
          }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _c("i", {
              staticClass: "fa",
              class: {
                "fa-caret-down": _vm.collapseFeeItem.feeWeight === true,
                "fa-caret-right": _vm.collapseFeeItem.feeWeight === false
              }
            }),
            _vm._v(" Phí cân nặng "),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.order.isEcommerceLine ? "(TMĐT)" : "") + " ")
            ])
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(_vm._f("formatNumber")(_vm.order.feeWeightAmount, "0,0"))
              )
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeWeight === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v("\n                - Giá cân nặng\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(_vm._s(_vm._f("formatNumber")(_vm.order.feeWeight, "0,0")))
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeWeight === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v("\n                - Phí cân nặng gốc\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(_vm._s(_vm._f("formatNumber")(_vm.feeWeightOrigin, "0,0")))
            ]),
            _vm._v("\n                ("),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(
                _vm._s(
                  _vm._f("formatNumber")(_vm.order.orderWeight, "0,0.[00000]")
                ) + " kg"
              )
            ]),
            _vm._v(")\n            ")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeWeight === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v("\n                - Chiết khấu\n            ")
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(
                  _vm._f("formatNumber")(
                    _vm.feeWeightOrigin - _vm.feeWeightBeforeDiscountLate,
                    "0,0"
                  )
                )
              )
            ]),
            _vm._v("\n                ("),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.order.feeWeightDiscount) + "%")
            ]),
            _vm._v(")\n            ")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "fee-box",
          class: { hide: _vm.collapseFeeItem.feeWeight === false }
        },
        [
          _c("div", { staticClass: "fee-label" }, [
            _vm._v(
              "\n                - Giảm cước vận chuyển đơn trễ\n            "
            )
          ]),
          _c("div", { staticClass: "fee-val" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(
                  _vm._f("formatNumber")(
                    _vm.feeWeightBeforeDiscountLate - _vm.order.feeWeightAmount,
                    "0,0"
                  )
                )
              )
            ]),
            _vm._v("\n                ("),
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.order.feeWeightDelayDiscount) + "%")
            ]),
            _vm._v(")\n            ")
          ])
        ]
      ),
      _vm.order.feeFragileGoods > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label" }, [
              _vm._v("\n                Phí đóng gỗ "),
              _c("span", { staticClass: "text-danger" }, [
                _vm._v(
                  "(¥" +
                    _vm._s(
                      _vm._f("formatNumber")(
                        _vm.order.feeFragileGoods,
                        "0,0.[000]"
                      )
                    ) +
                    ")"
                )
              ])
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(_vm.order.feeFragileGoodsVND, "0,0")
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.order.feeCheck > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label" }, [
              _vm._v("\n                Phí bảo hiểm\n            ")
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.order.feeCheck, "0,0"))
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.order.feeCreateOrderAmount > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label" }, [
              _vm._v("\n                Phí lên đơn hộ\n            ")
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      _vm.order.feeCreateOrderAmount,
                      "0,0"
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.order.feeStorage + _vm.order.lastFeeStorage > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label" }, [
              _vm._v("\n                Phí lưu kho\n            ")
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      _vm.order.feeStorage + _vm.order.lastFeeStorage,
                      "0,0"
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Tổng cộng\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(
              _vm._s(_vm._f("formatNumber")(_vm.order.totalAmountVND, "0,0"))
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Đã thanh toán\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", {
            staticClass: "text-primary",
            domProps: { innerHTML: _vm._s(_vm.deposit) }
          })
        ])
      ]),
      _vm.order.promofeebuy > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label text-primary" }, [
              _vm._v(
                "\n                Giảm phí dịch vụ (" +
                  _vm._s(_vm.order.promofeebuy) +
                  "%)\n            "
              )
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      (_vm.order.promofeebuy / 100) * _vm.order.feeBuyAmount,
                      "0,0"
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.order.promofeeweight > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label text-primary" }, [
              _vm._v(
                "\n                Giảm phí cân nặng (" +
                  _vm._s(_vm.order.promofeeweight) +
                  "%)\n            "
              )
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      (_vm.order.promofeeweight / 100) *
                        _vm.order.feeWeightAmount,
                      "0,0"
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label text-danger" }, [
          _vm._v("\n                Cần thanh toán\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatNumber")(
                  _vm.needPayment > 0 ? _vm.needPayment : 0,
                  "0,0"
                )
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }